import React from 'react'

export interface PageHeadingProps {
  children: React.ReactNode
}

export function PageHeading({ children }: PageHeadingProps) {
  return <h1 className="m-none txt-xxl fw-3 gray-darker">{children}</h1>
}
